window.LoginView = function () {
	const _self       = this,
		  _components = {
			  $emailInput: $('#input_email'),
			  $passwordInput: $('#input_password'),
			  $loginBtn: $('form .btn[type="submit"]'),
		  };

	/**
	 * init function
	 *
	 * @private
	 */
	function _init () {
		_activateLoginBtn();
	}

	/**
	 * Afficher des champs de formulaire différentes en fonction du type de compte
	 *
	 * @private
	 */
	function _activateLoginBtn () {
		_components.$emailInput.on('keyup keypress blur change', function () {
			console.log('test')
			if (_components.$passwordInput.val().length >= 8 && _components.$emailInput.val() !== '') {
				_components.$loginBtn.removeClass('disabled');
			} else {
				_components.$loginBtn.addClass('disabled');
			}
		});

		_components.$passwordInput.on('keyup keypress blur change', function () {
			console.log('test')
			if (_components.$passwordInput.val().length >= 8 && _components.$emailInput.val() !== '') {
				_components.$loginBtn.removeClass('disabled');
			} else {
				_components.$loginBtn.addClass('disabled');
			}
		});
	}

	_init();
};
